import React from 'react';

const SvgSuccessPackYourBags = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 300 300"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tourlane-EnquiryExperience-SuccessPackYourBags__linearGradient-5",
  x1: "50%",
  x2: "11.905%",
  y1: "43.959%",
  y2: "43.959%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#59DD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50C871"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tourlane-EnquiryExperience-SuccessPackYourBags__linearGradient-6",
  x1: "70.879%",
  x2: "23.505%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#59DD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50C871"
})), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessPackYourBags__path-1",
  d: "M6.217 12.613c-1.026 15.25-1.026 24.569 0 27.959.903 2.988 2.271 8.146 4.104 15.474a4.951 4.951 0 003.877 3.662l3.586.683a28.894 28.894 0 01-9.89 19.636l-1.047.906C1.427 91.08-.776 97.161.24 99.18c1.017 2.02 6.346 4.088 15.988 6.206 29.224-4.015 43.835-6.33 43.835-6.947s-3.104-6.193-9.312-16.728l-.959-2.182a32.023 32.023 0 01-2.49-16.555l.116-1.011a16.024 16.024 0 017.346-11.698L56.26 29.09l-5.508-4.828c-1.824-11.065-3.306-17.005-4.446-17.82-1.71-1.22-14.761-3.93-16.678-4.996C28.35.736 21.668.253 9.583 0L6.217 12.613z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessPackYourBags__path-3",
  d: "M97.142 0l9.761 3.77a24.782 24.782 0 019.774 6.858 19.784 19.784 0 014.728 10.755l3.42 30.199-15.508 67.627H23.969V66.445c-7.637-2.398-13.064-4.73-16.28-6.994l-.256-.183C4.252 56.946 1.838 54.603.19 52.239l12.518-24.173a46.069 46.069 0 0112.07-14.741A46.513 46.513 0 0141.77 4.692L59.146 0l10.48 13.344a21.592 21.592 0 0020.275 8.002c.41-.064.817-.15 1.218-.258 6.028-1.625 9.598-7.83 7.973-13.857L97.142 0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F7",
  d: "M285.363 281.713V121.979a3.059 3.059 0 00-5.277-2.106 8.105 8.105 0 01-11.12.599l-.732-.62a10.163 10.163 0 00-13.148 0l-.116.098a10.34 10.34 0 01-13.378 0l-.142-.12a10.12 10.12 0 00-13.095 0 10.392 10.392 0 01-13.237.172l-.215-.172a11.007 11.007 0 00-13.805.004l-.144.116a11.232 11.232 0 01-14.092 0 11.232 11.232 0 00-14.091 0l-.214.172a10.61 10.61 0 01-13.52-.172l-.142-.12a10.12 10.12 0 00-13.096 0 10.12 10.12 0 01-13.095 0 10.12 10.12 0 00-13.095 0l-.142.12a10.34 10.34 0 01-13.378 0 4.062 4.062 0 00-6.689 3.097v158.666h185.963z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8CCCF",
  d: "M133.6 264.613v17.1h-9.262v-17.1h9.262zm7.125 0v17.1h-3.563v-17.1h3.563zm12.113 0v17.1h-3.563v-17.1h3.563zm12.825 0v17.1H156.4v-17.1h9.262zm37.05 0v17.1h-9.263v-17.1h9.263zm34.912 0v17.1h-9.262v-17.1h9.262zm-91.912 0v17.1h-1.425v-17.1h1.424zm32.062 0v17.1h-3.563v-17.1h3.563zm12.112 0v17.1h-3.562v-17.1h3.563zm34.913 0v17.1h-3.563v-17.1h3.563zm19.95 0v17.1h-3.563v-17.1h3.563zm7.125 0v17.1h-3.563v-17.1h3.563zm-81.225 0v17.1h-1.425v-17.1h1.425zm12.112 0v17.1h-1.424v-17.1h1.424zm24.938 0v17.1h-1.425v-17.1h1.425zm4.988 0v17.1h-1.425v-17.1h1.424zm4.987 0v17.1h-1.425v-17.1h1.425zm39.188 0v17.1h-1.425v-17.1h1.425zm4.987 0v17.1h-1.425v-17.1h1.425z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(99.4 177.688)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 139.65,
  height: 29.925,
  x: 24.225,
  fill: "#FFF",
  stroke: "#EDEFF0",
  strokeWidth: 1.069,
  rx: 1.425
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 9.025)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M94.786 5.938h60.313a.712.712 0 110 1.425H94.786a.712.712 0 110-1.426zM.713 5.938h60.313a.712.712 0 110 1.425H.712a.713.713 0 010-1.426z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.55,
  height: 8.55,
  x: 74.1,
  y: 1.9,
  fill: "#59DD7D",
  rx: 0.798,
  transform: "rotate(45 78.375 6.175)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(123.625 217.588)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 139.65,
  height: 29.925,
  fill: "#FFF",
  stroke: "#EDEFF0",
  strokeWidth: 1.069,
  rx: 1.425
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.838 9.025)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M62.77 5.938h60.22a.76.76 0 010 1.52H62.77a.76.76 0 010-1.52zM.76 5.938h29.35a.76.76 0 010 1.52H.76a.76.76 0 110-1.52z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.55,
  height: 8.55,
  x: 41.8,
  y: 1.9,
  fill: "#59DD7D",
  rx: 0.798,
  transform: "rotate(45 46.075 6.175)"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#C8CCCF",
  transform: "translate(122.2 146.338)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.023 3.449h138.5v1.425H2.023z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.563,
  cy: 3.905,
  r: 3.563,
  stroke: "#F7F7F7",
  strokeWidth: 2.138
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136.8,
  cy: 3.905,
  r: 3.563,
  stroke: "#F7F7F7",
  strokeWidth: 2.138
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  stroke: "#F7F7F7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.138,
  d: "M189.354 139.982l-4.747.002 3.622 7.266-1.688.002-1.689-1.913-4.347.003 1.95 4.857-1.959 4.864 4.351-.002 1.692-1.917 1.685-.001-3.635 7.27 4.752-.004 5.739-7.271 2.673-.003c.46 0 1.574-.379 2.423-.989.82-.59 1.257-1.338 1.258-1.958 0-.621-.438-1.37-1.258-1.96-.848-.609-1.963-.986-2.423-.986l-2.672.003-5.727-7.263z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M83.884 156.494l9.755 125.254H45.233h1.777c-15.361 0-27.814-12.453-27.814-27.814 0-1.48.118-2.958.353-4.419l5.253-32.649a25.574 25.574 0 0111.143-17.269 19.888 19.888 0 008.901-17.402l-.26-6.363c-.398-9.716 7.139-17.922 16.853-18.35l22.445-.988z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-5 935.832 1583.33)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessPackYourBags__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPackYourBags__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#EDEFF0",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPackYourBags__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D7DA",
  d: "M15.987 60.01c4.51.75 8.511.999 12.002.75 5.236-.375-7.274 6.833-13.642 4.866",
  mask: "url(#tourlane-EnquiryExperience-SuccessPackYourBags__mask-2)",
  transform: "rotate(-1 21.793 62.989)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M101.418 65.915c6.727-2.912 12.518-.159 17.371 8.26 8.318.316 13.446 3.031 15.387 8.147 1.94 5.115.435 10.042-4.516 14.782.016 2.603-.198 4.73-.641 6.384-.443 1.653-1.19 3.675-2.24 6.066.094-4.89-.018-8.54-.333-10.95-.316-2.41-1.243-5.315-2.78-8.714-4.157.97-9.554.97-16.191 0-9.957-1.456-17.251 2.158-19.098 6.23-1.847 4.071 2.225 7.368-.733 12.151-1.972 3.19-4.86 4.73-8.664 4.621.514 3.933.668 7.263.462 9.99-.206 2.729-.994 6.451-2.366 11.168-7.088-4.847-11.218-9.889-12.39-15.125-1.173-5.237-1.173-9.698 0-13.382-3.155-2.46-4.526-6.039-4.115-10.738.411-4.699 2.305-7.95 5.682-9.751.56-7.438 3.332-12.922 8.32-16.454 7.48-5.298 16.753 1.683 26.845-2.685z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.867 162.168)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessPackYourBags__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPackYourBags__path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#59DD7D",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPackYourBags__path-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M35.84 3.455c20.787 26.916 30.732 44.573 29.834 52.97-.898 8.4 3.019 10.777 11.75 7.134v-7.133c-6.796-17.378-12.655-29.508-17.577-36.39A4089.49 4089.49 0 0046.286 1.179L35.84 3.455zM99.201 1.179l7.425 2.008c11.44 20.085 17.542 34.214 18.305 42.388.763 8.174-.984 12.197-5.243 12.067l-2.525-2.935c-.716-8.182-2.223-15.7-4.522-22.55-2.299-6.852-6.779-17.178-13.44-30.978z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPackYourBags__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#tourlane-EnquiryExperience-SuccessPackYourBags__linearGradient-5)",
  d: "M23.383 67.037L38.876 51.42c14.19 6.206 21.95 11.104 23.278 14.694.948 2.563-25.2 25.662-38.77 24.88-3.63-.209-3.63-8.194 0-23.956z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPackYourBags__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#tourlane-EnquiryExperience-SuccessPackYourBags__linearGradient-6)",
  d: "M62.154 99.879c24.318 5.563-.993 21.515 0 33.266.992 11.751-15.943 16.538 0 18.186 10.628 1.098-3.617-.303-42.737-4.203-6.773-33.9-7.761-53.47-2.963-58.708 7.066-7.715 37.667 9.622 45.7 11.459z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPackYourBags__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M74.03 84.609c-27.469 20.98-46.217 32.231-56.245 33.751-10.029 1.52-11.278-1.662-3.75-9.545l41.55-24.206H74.03z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPackYourBags__mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M19.517 213.587L7.254 238.8a22.45 22.45 0 00-1.26 16.45 13.597 13.597 0 0011.432 9.49l.033.005a40.912 40.912 0 0017.314-1.726l43.941-14.252c16.256-1.133 24.7-4.604 25.334-10.413.394-3.618.543-7.537.446-11.758a8.19 8.19 0 00-8.188-8.002H84.54c-3.884 4.636-7.114 7.976-9.688 10.019-2.574 2.043-16.389 7.107-41.443 15.192l9.426-15.192c-6.954-3.265-11.984-6.03-15.091-8.298-3.107-2.268-5.85-4.51-8.228-6.728zM143.798 210.031v3.962h-5.697a5.956 5.956 0 00-5.904 5.168c-1.133 8.487-.867 13.88.796 16.175 1.98 2.733 4.246 3.92 6.8 3.564-.88 8.934 1.847 14.963 8.183 18.087 9.504 4.687 21.83 6.163 23.299 0 .583-2.445 1.876-8.878-2.182-15.59-1.84-3.044-7.175-8.329-16.005-15.855.363-5.036-.87-8.886-3.698-11.55-2.829-2.663-4.693-3.983-5.592-3.96z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8CCCF",
  strokeLinecap: "round",
  strokeWidth: 1.069,
  d: "M3.375 281.713L297 280.896"
})));

export default SvgSuccessPackYourBags;